import React, { lazy, useMemo } from 'react';

import ErrorBoundary from 'components/Common/ErrorBoundary';
import FleetOpsSuspense from 'FleetOpsSuspense';

import PopupEntityAppContext from './PopupEntityAppContext';

// Loaded when a popup first opens. This provider is on every page, and the
// screen (dashboards, reports, boards, scorecards) is most of the app.
const EntityDetailsShow = lazy(() => import('screens/EntityDetailsShow'));

const PoppedUpEntityApp = ({
  poppedUpApp,
  closeEntityPopup,
}: {
  poppedUpApp: {
    app: EntityDetails.App;
    entity: EntityDetails.Entity;
    entityValue: string;
  };
  closeEntityPopup: () => void;
}) => {
  const selectedEntity = useMemo((): EntityDetails.SelectedEntity => {
    return {
      type: poppedUpApp.entity,
      fieldValue: poppedUpApp.entityValue,
    };
  }, [poppedUpApp]);

  return (
    <ErrorBoundary>
      <PopupEntityAppContext.Provider
        value={{
          poppedUpApp,
          closeEntityPopup,
          selectedEntity,
        }}
      >
        {/*
         * We want to clear any entity mapping in our popups,
         * even for simplified users.
         * isEngagementMode: false does this
         */}
        <FleetOpsSuspense>
          <EntityDetailsShow isEngagementMode={false} />
        </FleetOpsSuspense>
      </PopupEntityAppContext.Provider>
    </ErrorBoundary>
  );
};

export default PoppedUpEntityApp;
